import {
	clampIconSize,
	lucideIconName,
	sanitizeIconColor,
	writeMdxAttribute,
} from "../extensions/mintlify/icon-html"

interface TurndownLike {
	addRule: (
		key: string,
		rule: {
			filter: (node: Node) => boolean
			replacement: (content: string, node: Node) => string
		},
	) => void
}

const isIcon = (node: Node): boolean =>
	node.nodeName === "SPAN" &&
	(node as HTMLElement).getAttribute("data-type") === "icon"

export function iconMdx(element: HTMLElement): string {
	const icon = lucideIconName(element.getAttribute("data-icon"))
	if (!icon) return ""
	const size = clampIconSize(element.getAttribute("data-size"))
	const color = sanitizeIconColor(element.getAttribute("data-color"))
	const parts = [
		writeMdxAttribute("icon", icon),
		size ? `size={${size}}` : "",
		color ? writeMdxAttribute("color", color) : "",
	].filter(Boolean)
	return `<Icon ${parts.join(" ")} />`
}

export function addIconMarkdownRules(turndown: TurndownLike): void {
	turndown.addRule("mintlifyIcon", {
		filter: isIcon,
		replacement: (_content, node) => iconMdx(node as HTMLElement),
	})
}
